import { render, staticRenderFns } from "./outboundReviewProductRecords.vue?vue&type=template&id=4d5afd10&scoped=true"
import script from "./outboundReviewProductRecords.vue?vue&type=script&lang=js"
export * from "./outboundReviewProductRecords.vue?vue&type=script&lang=js"
import style0 from "./outboundReviewProductRecords.vue?vue&type=style&index=0&id=4d5afd10&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5afd10",
  null
  
)

export default component.exports